import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchDatasetsPage({ payload: params }: any) {
    try {
        const data = yield call(service.fetchDatasetsPage, params);

        yield put(actions.fetchDatasetsSuccess(data, params));
    } catch (error) {
        yield put(actions.fetchDatasetsError(error.message));
    }
}

function* fetchDatasetsFilters() {
    try {
        const data = yield call(service.fetchDatasetsFilters);

        yield put(actions.fetchDatasetsFiltersSuccess(data));
    } catch (error) {
        yield put(actions.fetchDatasetsFiltersError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_DATASETS_PAGE, fetchDatasetsPage);
    yield takeLatest(types.FETCH_DATASETS_FILTERS, fetchDatasetsFilters);
}
